import { render, staticRenderFns } from "./ChatMensagemContainer.vue?vue&type=template&id=4228ea65&scoped=true"
import script from "./ChatMensagemContainer.vue?vue&type=script&lang=js"
export * from "./ChatMensagemContainer.vue?vue&type=script&lang=js"
import style0 from "./ChatMensagemContainer.vue?vue&type=style&index=0&id=4228ea65&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228ea65",
  null
  
)

export default component.exports